// extracted by mini-css-extract-plugin
export default {"container":"Chat-module__container--da1e1","status":"Chat-module__status--a6a25"};